module.exports = __webpack_public_path__ + "assets/img/zfb.3140ce29.png";